import { motion } from "framer-motion";
import {
  Instagram,
  Youtube,
  Facebook,
  Twitter,
  Linkedin,
  Music,
  Music2,
  Globe,
  ShoppingBag,
  Mail,
  MessageCircle,
  Link as LinkIcon,
  ArrowUpRight,
} from "lucide-react";

const iconMap = {
  instagram: Instagram,
  youtube: Youtube,
  facebook: Facebook,
  twitter: Twitter,
  linkedin: Linkedin,
  tiktok: Music2,
  spotify: Music,
  globe: Globe,
  shop: ShoppingBag,
  mail: Mail,
  whatsapp: MessageCircle,
  link: LinkIcon,
};

export default function ExternalLinks({ data }) {
  const items = (data.items || []).filter((i) => i.enabled !== false);
  if (items.length === 0) return null;

  return (
    <section data-testid="external-links-section" className="py-24 lg:py-32 bg-onyx text-alabaster relative overflow-hidden">
      {/* Decorative gold blur */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-gold blur-[180px]" />
      </div>

      <div className="relative max-w-2xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="overline mb-4 text-gold" data-testid="external-links-overline">{data.overline}</p>
          <h2
            data-testid="external-links-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-tight"
          >
            {data.title}
          </h2>
          {data.subtitle && (
            <p className="mt-4 text-alabaster/70" data-testid="external-links-subtitle">{data.subtitle}</p>
          )}
        </div>

        <div className="space-y-3">
          {items.map((item, i) => {
            const Icon = iconMap[item.icon] || LinkIcon;
            return (
              <motion.a
                key={i}
                href={item.url}
                target="_blank"
                rel="noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                data-testid={`external-link-${i}`}
                className="group flex items-center gap-5 p-5 bg-alabaster/[0.04] border border-alabaster/10 hover:bg-gold hover:border-gold hover:text-onyx transition-all duration-300"
              >
                <span className="flex-shrink-0 w-12 h-12 rounded-full bg-gold text-onyx flex items-center justify-center group-hover:bg-onyx group-hover:text-gold transition-colors">
                  <Icon size={20} strokeWidth={1.5} />
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block font-serif text-xl leading-tight">{item.label}</span>
                  {item.description && (
                    <span className="block text-xs mt-1 opacity-70 truncate">{item.description}</span>
                  )}
                </span>
                <ArrowUpRight size={20} className="flex-shrink-0 opacity-50 group-hover:opacity-100 transition-opacity" strokeWidth={1.5} />
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
